export default __webpack_public_path__ + "static/media/Kayak_Rentals_Bottom.5b6fdd42.png";